var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scan-summary" },
    [
      _c(
        "page-header",
        {
          attrs: { paths: ["扫描批次", "全区数据"], title: _vm.exam.examName },
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: {
                loading: _vm.downloadLoading,
                type: "text",
                size: "mini",
              },
              on: {
                click: function ($event) {
                  return _vm.exportStudent()
                },
              },
            },
            [
              _vm._v(" 未上传名单 "),
              _c("span", { staticClass: "el-icon-download" }),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "list-wrapper" }, [
        _c(
          "div",
          { staticClass: "list-title" },
          [
            _vm.notUploadInfo.schoolCount > 0 &&
            _vm.notUploadInfo.studentCount > 0
              ? _c(
                  "div",
                  [
                    _vm._v(" 该考试现有 "),
                    _c("span", { staticClass: "red-text" }, [
                      _vm._v(_vm._s(_vm.notUploadInfo.schoolCount)),
                    ]),
                    _vm._v("所学校 "),
                    _c("span", { staticClass: "red-text" }, [
                      _vm._v(_vm._s(_vm.notUploadInfo.studentCount)),
                    ]),
                    _vm._v("名学生 未上传答题卡，这些学生将没有成绩 "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.jumpDetail()
                          },
                        },
                      },
                      [_vm._v("去查看")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("el-input", {
              staticStyle: { width: "200px" },
              attrs: {
                placeholder: "搜索学校",
                "prefix-icon": "el-icon-search",
                clearable: "",
              },
              on: {
                clear: function ($event) {
                  return _vm.handleLogCurrentChange(1)
                },
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleLogCurrentChange(1)
                },
              },
              model: {
                value: _vm.search.keyWord,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "keyWord", $$v)
                },
                expression: "search.keyWord",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "list-item" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  data: _vm.schoolList,
                  border: "",
                  "default-sort": { prop: "totalCount", order: "descending" },
                },
                on: { "sort-change": _vm.handleSortChange },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "center", prop: "schoolName", label: "学校" },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "totalCount",
                    label: "计划总量",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "uploadedCount",
                    label: "已上传量",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "rceCount",
                    label: "已识别量",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "unUploadCount",
                    label: "未上传量",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class:
                                scope.row.unUploadCount > 0 ? "red-text" : "",
                            },
                            [_vm._v(_vm._s(scope.row.unUploadCount))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "noNamePaperCount",
                    label: "无名卷量",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class:
                                scope.row.noNamePaperCount > 0
                                  ? "red-text"
                                  : "",
                            },
                            [_vm._v(_vm._s(scope.row.noNamePaperCount))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "absentCount",
                    label: "缺考",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class:
                                scope.row.absentCount > 0 ? "red-text" : "",
                            },
                            [_vm._v(_vm._s(scope.row.absentCount))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "zeroCount",
                    label: "0分卷",
                    sortable: "",
                    "sort-orders": ["descending", "ascending"],
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: scope.row.zeroCount > 0 ? "red-text" : "",
                            },
                            [_vm._v(_vm._s(scope.row.zeroCount))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "100",
                    prop: "schoolId",
                    label: "操作",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.jumpDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v(" 查看详情 ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.page.total > _vm.page.size
              ? _c("yue-pagination", {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { page: _vm.page },
                  on: { "current-change": _vm.handleLogCurrentChange },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }